import {
  ADD_TO_CART,
  REMOVE_FROM_CART,
  CLEAR_CART,
} from "./domainAddToCart.type";

const INITIAL_STATE = [];

const domainAddToCartReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADD_TO_CART: {
      const incomingItems = action.payload;

      return [
        ...state,
        ...incomingItems.filter(
          item => !state.some(existing => existing.id === item.id)
        ),
      ];
    }

    case REMOVE_FROM_CART: {
      const idsToRemove = action.payload;
      return state.filter(item => !idsToRemove.includes(item.id));
    }

    case CLEAR_CART:
      return [];

    default:
      return state;
  }
};

export default domainAddToCartReducer;
